import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface LiveModalInfoJson {
  width?: number;
  visible: boolean;
  content: string;
  descContent?: string;
  cancelText?: string;
  saveText?: string;
  zIndex?: number;
  isSave?: boolean;
  returnInfo?: any;
}

export interface BaseTipLiveInfoState {
  width?: number;
  visible: boolean;
  content: string;
  descContent?: string;
  cancelText?: string;
  saveText?: string;
  zIndex?: number;
  isSave?: boolean;
  returnInfo?: any;
  returnLiveBaseEvent?: (info?: any) => void;
}

const localBaseInfo = LocalStore.getValue<BaseTipLiveInfoState>('BASE_TIP_LIVE_INFO') || {};

export const baseTipLiveInfo: BaseTipLiveInfoState = {
  visible: false,
  content: '',
  ...localBaseInfo
};

export const setBaseTipLiveInfo: (payload: BaseTipLiveInfoState) => IAction<BaseTipLiveInfoState> = (
  payload: BaseTipLiveInfoState
) => ({
  type: 'setBaseTipLiveInfo',
  payload
});

const baseTipLiveReducer: Reducer<BaseTipLiveInfoState, IAction<any>> = (
  state = baseTipLiveInfo,
  action: IAction<any>
) => {
  const { type, payload } = action;
  switch (type) {
    case 'setBaseTipLiveInfo':
      LocalStore.setValue('BASE_TIP_LIVE_INFO', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default baseTipLiveReducer;
